import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { formatDateTimeDisplayString } from "@/lib/string-utils";
import AttachmentImage from "./AttachmentImage";

interface ImagePreviewDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  imageUrl?: string | null;
  alt?: string;
  dateTaken?: string | null;
  createdByName?: string | null;
  isProcessing?: boolean;
}

const ImagePreviewDialog: React.FC<ImagePreviewDialogProps> = ({
  open,
  onOpenChange,
  title,
  imageUrl,
  alt,
  dateTaken,
  createdByName,
  isProcessing = false,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[90vw] w-fit p-2 sm:p-4">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        {(imageUrl || isProcessing) && (
          <div className="space-y-2">
            <AttachmentImage
              url={imageUrl}
              isProcessing={isProcessing}
              alt={alt ?? title}
              className="max-h-[85vh] max-w-[85vw] min-h-64 min-w-64 rounded-lg object-contain"
            />
            {dateTaken && (
              <p className="text-sm text-muted-foreground text-center">
                {formatDateTimeDisplayString(dateTaken)}
              </p>
            )}
            {createdByName && (
              <p className="text-sm text-muted-foreground text-center">
                Created by: {createdByName}
              </p>
            )}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ImagePreviewDialog;
